import { useAuth } from 'react-oidc-context';
export function useIdentityAuth() {
  var _useAuth = useAuth(),
    user = _useAuth.user;
  return {
    accessToken: user === null || user === void 0 ? void 0 : user.access_token,
    idToken: user === null || user === void 0 ? void 0 : user.id_token,
    user: user
  };
}